'use client';

import React, { PropsWithChildren } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { Provider as ReduxProvider } from 'react-redux';
import { ThemeProvider } from '@/containers';
import { appStore } from '@/store';

export function MaintenanceProviders({ children }: PropsWithChildren) {
  return (
    <ReduxProvider store={appStore}>
      <ThemeProvider>
        <CssBaseline />
        <div>{children}</div>
      </ThemeProvider>
    </ReduxProvider>
  );
}
